// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const appInfo = z.object({
    app_name: z.string().optional(),
    app_version: z.string().optional(),
    build_number: z.string().optional(),
    login_type: z.string().optional(),
    first_install_time: z.string().optional(),
    last_update_time: z.string().optional(),
    position_sharing_active: z.boolean().optional(),
    battery_optimization_enabled: z.boolean().optional(),
    notification_permission_granted: z.boolean().optional(),
    notifications_enabled: z.boolean().optional(),
    camera_permission_granted: z.boolean().optional(),
    location_permission_granted: z.boolean().optional(),
    analytics_enabled: z.boolean().optional(),
    crash_report_enabled: z.boolean().optional(),
    app_state: z.string().optional(),
    is_prod: z.boolean().optional(),
    offline_queue_length: z.int().optional(),
});

export const bookedFeatures = z.object({
    booking: z.string().optional(),
    'order-communication': z.boolean().optional(),
    'webfleet-navigation': z.boolean().optional(),
    'position-sharing': z.boolean().optional(),
    chat: z.boolean().optional(),
    'driver-license-check': z.boolean().optional(),
    'pre-departure-check': z.boolean().optional(),
    'damage-report': z.boolean().optional(),
    'sign-on-glass': z.boolean().optional(),
    'staff-features': z.boolean().optional(),
    'skip-tour-stop': z.boolean().optional(),
});

export const deviceInfo = z.object({
    os: z.string().optional(),
    manufacturer: z.string().optional(),
    brand: z.string().optional(),
    device: z.string().optional(),
    gps_enabled: z.boolean().optional(),
    device_type: z.string().optional(),
    google_play_services_available: z.boolean().optional(),
    is_emulator: z.boolean().optional(),
    is_landscape: z.boolean().optional(),
});

export const powerState = z.object({
    battery_state: z.string().optional(),
    battery_level: z.number().optional(),
    low_power_mode: z.boolean().optional(),
});

export const appVersionInfo = z.object({
    app_version: z.string().optional(),
    count: z.int().optional(),
});

export const aggregatedStatusSummary = z.object({
    accounts: z.int(),
    devices: z.int(),
    users: z.int(),
    users_with_driver_login: z.int(),
    users_with_app_login: z.int(),
    users_with_cartright: z.int(),
    users_with_cartright_standard: z.int(),
    users_with_cartright_enterprise: z.int(),
    users_with_order_com_rio_fms: z.int(),
    users_with_order_com_third_party: z.int(),
    users_with_unknown_booking: z.int(),
    users_without_booking: z.int(),
    app_versions: z.array(appVersionInfo),
});

export const rioAsset = z.object({
    rio_asset_id: z.string(),
    login_type: z.string().optional(),
});

export const accountActivity = z.object({
    account_id: z.string(),
    users: z.int(),
    is_rio_account: z.boolean(),
    assets: z.array(rioAsset),
});

export const dailyActivities = z.object({
    date: z.string(),
    users: z.int(),
    users_with_cartright: z.int(),
    users_with_cartright_standard: z.int(),
    users_with_cartright_enterprise: z.int(),
    users_with_order_com_rio_fms: z.int(),
    users_with_order_com_third_party: z.int(),
    users_with_unknown_booking: z.int(),
    users_without_booking: z.int(),
    users_with_app_login: z.int(),
    users_with_driver_login: z.int(),
    activities: z.array(accountActivity),
});

export const aggregatedDailyActivities = z.object({
    activities: z.array(dailyActivities),
});

export const aggregatedBookingsSummary = z.object({
    accounts: z.int(),
    active_bookings: z.int(),
    pending_bookings: z.int(),
    deactivated_bookings: z.int(),
});

export const accountEventsSummary = z.object({
    tour_started: z.int(),
    tour_finished: z.int(),
    problem_reported: z.int(),
    handling_unit_loading_confirmed: z.int(),
    handling_unit_unloading_confirmed: z.int(),
    handling_unit_loading_confirmed_with_deviation: z.int(),
    handling_unit_unloading_confirmed_with_deviation: z.int(),
    swap_body_loading_confirmed: z.int(),
    swap_body_unloading_confirmed: z.int(),
    trailer_loading_confirmed: z.int(),
    trailer_unloading_confirmed: z.int(),
});

export const dailyAccountEvents = z.object({
    date: z.string(),
    tour_started: z.int(),
    tour_finished: z.int(),
    problem_reported: z.int(),
});

export const accountEvents = z.object({
    account_id: z.string(),
    summary: accountEventsSummary,
    events: z.array(dailyAccountEvents),
});

/**
 * Enum of all possible tour event types.
 */
export const tourEventType = z.string();

export const tourEventInitiator = z.object({
    client_id: z.string(),
    subject_id: z.string().optional(),
    asset_id: z.string().optional(),
});

export const customer = z.object({
    id: z.string(),
    name: z.string(),
    is_rio_account: z.boolean(),
});

export const customers = z.object({
    customers: z.array(customer),
});

/**
 * An ISO 8601 formatted timestamp.
 */
export const timestamp = z.string();

export const baseStatus = z.object({
    timestamp: timestamp.optional(),
    app_info: appInfo.optional(),
    bookings: bookedFeatures.optional(),
    device_info: deviceInfo.optional(),
    power_state: powerState.optional(),
});

export const userActivity = z.object({
    timestamp,
    account_id: z.string(),
    rio_asset_id: z.string().optional(),
    device_id: z.string(),
    login_type: z.string().optional(),
    app_version: z.string().optional(),
    bookings: bookedFeatures.optional(),
});

export const dailyAccountActivities = z.object({
    date: z.string(),
    users: z.int(),
    activities: z.array(userActivity),
});

export const accountActivities = z.object({
    account_id: z.string(),
    is_rio_account: z.boolean(),
    activities: z.array(dailyAccountActivities),
});

export const tourEvent = z.object({
    id: z.string().optional(),
    account_id: z.string().optional(),
    tour_id: z.string().optional(),
    occurred_at: timestamp.optional(),
    triggered_at: timestamp.optional(),
    device_id: z.string().optional(),
    initiator: tourEventInitiator.optional(),
    event_type: tourEventType.optional(),
});

/**
 * Often a UUID. But there are exceptions. Always handle an ID as a string.
 */
export const idString = z.string();

export const deviceSummary = z.object({
    timestamp,
    device_id: idString,
    asset_id: idString.optional(),
    app_version: z.string().optional(),
    os: z.string().optional(),
    login_type: z.string().optional(),
    booking: z.string().optional(),
});

export const assetSummary = z.object({
    asset_id: idString,
    login_type: z.string().optional(),
    booking: z.string().optional(),
    devices: z.array(deviceSummary),
});

export const aggregatedAccountStatus = z.object({
    account_id: idString,
    is_rio_account: z.boolean(),
    devices: z.int(),
    users: z.int(),
    users_with_cartright: z.int(),
    users_with_cartright_standard: z.int(),
    users_with_cartright_enterprise: z.int(),
    users_with_order_com_rio_fms: z.int(),
    users_with_order_com_third_party: z.int(),
    users_with_unknown_booking: z.int(),
    users_without_booking: z.int(),
    tour_start_events: z.int(),
    assets: z.array(assetSummary),
});

export const aggregatedStatusList = z.object({
    summary: aggregatedStatusSummary,
    accounts: z.array(aggregatedAccountStatus),
});

export const writeStatus = baseStatus.and(
    z.object({
        driver_id: idString.optional(),
        vehicle_id: idString.optional(),
    })
);

export const status = baseStatus.and(
    z.object({
        account_id: idString,
        device_id: idString,
        asset_id: idString.optional(),
        is_rio_account: z.boolean().optional(),
    })
);

export const assetStatus = z.object({
    asset_id: idString,
    devices: z.array(status),
});

export const aggregatedAccountStatusList = z.object({
    account_id: idString,
    summary: aggregatedStatusSummary,
    assets: z.array(assetStatus),
});

export const booking = z.object({
    account_id: idString,
    asset_id: idString,
    status: z.string(),
    timestamp: timestamp.optional(),
});

export const aggregatedAccountBookings = z.object({
    account_id: idString,
    active_bookings: z.int(),
    pending_bookings: z.int(),
    deactivated_bookings: z.int(),
    bookings: z.array(booking),
});

export const aggregatedBookings = z.object({
    summary: aggregatedBookingsSummary,
    accounts: z.array(aggregatedAccountBookings),
});

/**
 * The id of the `Account` for which to retrieve or update data.
 */
export const accountId = idString;

/**
 * Determines if entries from rio accounts should be returned.
 */
export const includeRio = z.boolean().default(false);

/**
 * Start date from which to retrieve data.
 */
export const start = z.string();

/**
 * End date until which to retrieve data.
 */
export const end = z.string();

export const zGetStatusQuery = z.object({
    include_rio: z.boolean().optional().default(false),
    start: z.string().optional(),
});

/**
 * Ok
 */
export const zGetStatusResponse = aggregatedStatusList;

export const zPutStatusBody = writeStatus;

export const zGetStatusByAccountIdPath = z.object({
    'account-id': idString,
});

export const zGetStatusByAccountIdQuery = z.object({
    start: z.string().optional(),
});

/**
 * Ok
 */
export const zGetStatusByAccountIdResponse = aggregatedAccountStatusList;

export const zGetActivityQuery = z.object({
    include_rio: z.boolean().optional().default(false),
    start: z.string().optional(),
    end: z.string().optional(),
});

/**
 * Ok
 */
export const zGetActivityResponse = aggregatedDailyActivities;

export const zGetActivityByAccountIdPath = z.object({
    'account-id': idString,
});

export const zGetActivityByAccountIdQuery = z.object({
    start: z.string().optional(),
    end: z.string().optional(),
});

/**
 * Ok
 */
export const zGetActivityByAccountIdResponse = accountActivities;

/**
 * Ok
 */
export const zGetBookingsResponse = aggregatedBookings;

export const zGetEventsByAccountIdPath = z.object({
    'account-id': idString,
});

export const zGetEventsByAccountIdQuery = z.object({
    start: z.string().optional(),
    end: z.string().optional(),
});

/**
 * Ok
 */
export const zGetEventsByAccountIdResponse = accountEvents;

/**
 * Ok
 */
export const zGetCustomersResponse = customers;

export const zPutCustomersBody = customers;

export const zGetCustomersByAccountIdPath = z.object({
    'account-id': idString,
});

/**
 * Ok
 */
export const zGetCustomersByAccountIdResponse = customer;
